import { render, staticRenderFns } from "./PasswordSettingPageDemo.vue?vue&type=template&id=73829195&scoped=true"
import script from "./PasswordSettingPageDemo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordSettingPageDemo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PasswordSettingPageDemo.vue?vue&type=style&index=0&id=73829195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73829195",
  null
  
)

export default component.exports